import { render, staticRenderFns } from "./RightSidebar.html?vue&type=template&id=1753c7a3&scoped=true&"
import script from "./RightSidebar.js?vue&type=script&lang=js&"
export * from "./RightSidebar.js?vue&type=script&lang=js&"
import style0 from "./RightSidebar.scss?vue&type=style&index=0&id=1753c7a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1753c7a3",
  null
  
)

export default component.exports